import Swiper, { Autoplay, Navigation, Grid, Pagination } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

/* =========================
   HELPERS
========================= */

// NEW: debounce
function debounce(fn, delay = 150) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), delay);
  };
}

// NEW: calc max height for wrapper
function applyWrapperMaxHeight(wrapper, slides) {
  if (!wrapper || slides.length < 3) return;

  const heights = [...slides].map(slide => slide.offsetHeight);
  heights.sort((a, b) => b - a);

  const maxHeight = heights[0] + heights[1] + 100;
  wrapper.style.maxHeight = `${maxHeight}px`;
}

let testimonialsSwiperWr = document.querySelectorAll('.testimonials-swiper-wr');
testimonialsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let paginationEl = el.querySelector('.swiper-pagination');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let slides = el.querySelectorAll('.swiper-slide');
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    // NEW: debounced resize handler
    const debouncedResizeCalc = debounce(() => {
      applyWrapperMaxHeight(wrapper, slides);

      setTimeout(function () {
        if(slides.length) {
          lineTitlesFunc(slides);
        }
      }, 10)
    }, 150);

    swiperEl.classList.add(`slides-length-${slides.length}`);

    if(slides.length <= 1000) {
      let swiper = new Swiper(swiperEl, {
        modules: [Autoplay, Navigation, Pagination],
        observer: true, //needs to calculate swiper size
        observeParents: true, //needs to calculate swiper size
        spaceBetween: 16,
        slidesPerView: 1,
        speed: 500,
        threshold: 10,
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        breakpoints: {
          641: {
            slidesPerView: 2,
            spaceBetween: 12,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
          850: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1250: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: window.innerWidth >= 1033,
        },
      });
      swiperObserver(swiper);
    } else {
      swiperEl.classList.add('swiper-grid-type');
      let swiper = new Swiper(swiperEl, {
        modules: [Autoplay, Navigation, Grid, Pagination],
        observer: true, //needs to calculate swiper size
        observeParents: true, //needs to calculate swiper size
        spaceBetween: 16,
        slidesPerView: 1,
        speed: 500,
        threshold: 10,
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        breakpoints: {
          641: {
            slidesPerView: 2,
            spaceBetween: 12,
            grid: {
              rows: 2,
              fill: 'row',
            },
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 16,
            grid: {
              rows: 2,
              fill: 'row',
            },
          },
          850: {
            slidesPerView: 2,
            spaceBetween: 20,
            grid: {
              rows: 2,
              fill: 'row',
            },
          },
          1250: {
            slidesPerView: 3,
            spaceBetween: 30,
            grid: {
              rows: 2,
              fill: 'row',
            },
          },
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: window.innerWidth >= 1033,
        },
        on: {
          afterInit() {
            // existing logic
            wrapper.scrollWidth >= wrapper.clientWidth
                ? wrapper.classList.remove('justify-center')
                : wrapper.classList.add('justify-center');

            // NEW: initial calc
            if (slidesCount >= 3) {
              applyWrapperMaxHeight(wrapper, slides);

              // NEW: second recalculation after init
              setTimeout(() => {
                applyWrapperMaxHeight(wrapper, slides);
              }, 100);
            }
          },

          resize() {
            // existing logic
            wrapper.scrollWidth >= wrapper.clientWidth
                ? wrapper.classList.remove('justify-center')
                : wrapper.classList.add('justify-center');

            // NEW: debounced resize calc
            if (slidesCount >= 3) {
              debouncedResizeCalc();
            }
          },
        },
      });
      swiperObserver(swiper);
    }

  }
});